import { v2Colors } from '@web-for-marketing/react-ui';
import { FooterBackground } from '@models/footer';

export const footerBackgroundColors = {
    [FooterBackground.DarkBlue]: v2Colors.core.deepSpace,
    [FooterBackground.Black]: '#000000',
};
